import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const InfoSheet = ({ isOpen, onClose, title, message, theme }) => {
  const primaryColor = theme?.primary || '#000';
  const secondaryColor = theme?.secondary || '#fff';

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100]"
          />

          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-[110] p-6 pb-12 shadow-2xl flex flex-col items-center text-center"
          >
            <div className="w-12 h-1 bg-gray-200 rounded-full mb-6" />
            
            <div className="w-16 h-16 rounded-2xl flex items-center justify-center text-3xl mb-4" style={{ backgroundColor: `${secondaryColor}15` }}>
              ℹ️
            </div>

            <h2 className="text-xl font-bold text-gray-900 mb-2">{title}</h2>
            <p className="text-sm text-gray-500 leading-relaxed max-w-xs mb-8">
              {message}
            </p>

            <button
              onClick={onClose}
              className="w-full py-4 rounded-2xl text-base font-black transition-all active:scale-95 shadow-lg"
              style={{ backgroundColor: secondaryColor, color: primaryColor }}
            >
              Got it
            </button>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default InfoSheet;
